import { MDText } from 'i18n-react';

import { SocialFacebookIcon, SocialInstagramIcon, SocialRedditIcon, SocialXIcon } from '@motorway/mw-highway-code';

import { getBereavementPathWithParams } from 'Utilities/helpers';
import { SITEMAP_HTML_URL } from 'Utilities/routing';
import { TAX_VALUATION_ROUTE, WHY_MOTORWAY_PATH, WHY_YOU_GET_MORE_PATH } from 'Utilities/wordpress';

import appleAppStoreIcon from '../../../../../../client/assets_seller/appStoreIcons/icon-app-store.svg';
import googlePlayStoreIcon from '../../../../../../client/assets_seller/appStoreIcons/icon-play-store.svg';
import Texts from '../../../../../texts.json';

const LocalT = new MDText(Texts);

const texts = {
  ancillaryAbout: LocalT.translate('footerView.company.ancillaryPages.aboutPageTitle'),
  ancillaryAuthors: LocalT.translate('authorsAndExpertsView'),
  ancillaryBlog: LocalT.translate('footerView.company.ancillaryPages.blogPageTitle'),
  ancillaryCareers: LocalT.translate('jobsView.title'),
  ancillaryContact: LocalT.translate('footerView.company.ancillaryPages.contactPageTitle'),
  ancillaryCookies: LocalT.translate('footerView.company.ancillaryPages.cookiesPageTitle'),
  ancillaryHowItWorks: LocalT.translate('howItWorksView.title'),
  ancillaryPress: LocalT.translate('footerView.siteLinks.links.press'),
  ancillaryPrivacy: LocalT.translate('footerView.company.ancillaryPages.privacyPageTitle'),
  ancillaryRefer: LocalT.translate('referView.title'),
  ancillaryReviews: LocalT.translate('footerView.company.ancillaryPages.customerReviewsPageTitle'),
  ancillaryServiceFees: LocalT.translate('footerView.siteLinks.links.serviceFeesExplained'),
  ancillarySitemap: LocalT.translate('footerView.siteLinks.links.sitemap'),
  ancillaryTerms: LocalT.translate('footerView.company.ancillaryPages.termsPageTitle'),
  ancillaryWhyMotorway: LocalT.translate('whyMotorwayView.title'),
  ancillaryWhyYouGetMore: LocalT.translate('whyYouGetMore.title'),

  ctaAppStoreDownload: LocalT.translate('footerView.cta.download.appStore'),
  ctaGooglePlayDownload: LocalT.translate('footerView.cta.download.googlePlay'),

  siteCarBuyers: LocalT.translate('footerView.siteLinks.links.carBuyers'),
  siteCarValueTracker: LocalT.translate('footerView.siteLinks.links.carValueTracker'),
  siteMotCheck: LocalT.translate('footerView.siteLinks.links.motCheck'),
  siteSellAfterABereavement: LocalT.translate('footerView.siteLinks.links.sellAfterABereavement'),
  siteSellMyCar: LocalT.translate('footerView.siteLinks.links.sellMyCar'),
  siteSellMyCarFinance: LocalT.translate('footerView.siteLinks.links.sellMyCarFinance'),
  siteSellMyVan: LocalT.translate('footerView.siteLinks.links.sellMyVan'),
  siteTaxCheck: LocalT.translate('footerView.siteLinks.links.taxCheck'),
  siteUlezCheck: LocalT.translate('footerView.siteLinks.links.ulezCheck'),

  socialFacebookLink: LocalT.translate('footerView.company.socialLinks.facebookLink'),
  socialFacebookTitle: LocalT.translate('footerView.company.socialLinks.facebookTitle'),
  socialInstagramLink: LocalT.translate('footerView.company.socialLinks.instagramLink'),
  socialInstagramTitle: LocalT.translate('footerView.company.socialLinks.instagramTitle'),
  socialRedditLink: LocalT.translate('footerView.company.socialLinks.redditLink'),
  socialRedditTitle: LocalT.translate('footerView.company.socialLinks.redditTitle'),
  socialTwitterLink: LocalT.translate('footerView.company.socialLinks.twitterLink'),
  socialTwitterTitle: LocalT.translate('footerView.company.socialLinks.twitterTitle'),
} as Record<string, string>;

export const pressRoutes = [
  { name: 'the-guardian', title: LocalT.translate('footerView.press.publications.publication1') },
  { name: 'the-times', title: LocalT.translate('footerView.press.publications.publication2') },
  { name: 'independent', title: LocalT.translate('footerView.press.publications.publication3') },
  { name: 'car-dealer', title: LocalT.translate('footerView.press.publications.publication4') },
  { name: 'tech-crunch', title: LocalT.translate('footerView.press.publications.publication5') },
  { name: 'sifted', title: LocalT.translate('footerView.press.publications.publication6') },
];

export const socialRoutes = [
  {
    icon: SocialFacebookIcon,
    link: texts.socialFacebookLink,
    name: 'facebook',
    title: texts.socialFacebookTitle,
  },
  {
    icon: SocialXIcon,
    link: texts.socialTwitterLink,
    name: 'x',
    title: texts.socialTwitterTitle,
  },
  {
    icon: SocialInstagramIcon,
    link: texts.socialInstagramLink,
    name: 'instagram',
    title: texts.socialInstagramTitle,
  },
  {
    icon: SocialRedditIcon,
    link: texts.socialRedditLink,
    name: 'reddit',
    title: texts.socialRedditTitle,
  },
];

export const aboutRoutes = [
  {
    link: '/about',
    title: texts.ancillaryAbout,
  },
  {
    link: WHY_MOTORWAY_PATH,
    title: texts.ancillaryWhyMotorway,
  },
  {
    external: true,
    link: 'https://careers.motorway.co.uk/',
    title: texts.ancillaryCareers,
  },
  {
    link: '/press',
    title: texts.ancillaryPress,
  },
  {
    link: '/how-it-works',
    title: texts.ancillaryHowItWorks,
  },
  {
    link: '/service-fees',
    title: texts.ancillaryServiceFees,
  },
  {
    link: WHY_YOU_GET_MORE_PATH,
    title: texts.ancillaryWhyYouGetMore,
  },
  {
    link: '/reviews',
    title: texts.ancillaryReviews,
  },
  {
    link: '/refer',
    title: texts.ancillaryRefer,
  },
  {
    link: '/blog',
    title: texts.ancillaryBlog,
  },
  {
    external: true,
    link: 'https://help.motorway.co.uk/hc/en-gb',
    title: texts.ancillaryContact,
  },
  {
    link: '/guides/authors',
    title: texts.ancillaryAuthors,
  },
];

export const siteRoutes = [
  {
    link: '/',
    title: texts.siteSellMyCar,
  },
  {
    link: '/sell-my-van',
    title: texts.siteSellMyVan,
  },
  {
    link: '/sell-my-car/on-finance',
    title: texts.siteSellMyCarFinance,
  },
  {
    link: getBereavementPathWithParams('/sell-my-car/bereavement'),
    title: texts.siteSellAfterABereavement,
  },
  {
    link: '/sell-my-car/car-buyers',
    title: texts.siteCarBuyers,
  },
];

export const toolsRoutes = [
  {
    link: '/car-value-tracker',
    title: texts.siteCarValueTracker,
  },
  {
    link: '/mot-check',
    title: texts.siteMotCheck,
  },
  {
    link: TAX_VALUATION_ROUTE,
    title: texts.siteTaxCheck,
  },
  {
    link: '/ulez-checker',
    title: texts.siteUlezCheck,
  },
];

export const ancillaryRoutes = [{
  link: '/terms',
  title: texts.ancillaryTerms,
},
{
  link: '/privacy',
  title: texts.ancillaryPrivacy,
},
{
  link: '/cookies',
  title: texts.ancillaryCookies,
},
{
  link: SITEMAP_HTML_URL,
  title: texts.ancillarySitemap,
}];

export const applicationRoutes = [{
  description: texts.ctaAppStoreDownload,
  icon: {
    height: 51,
    src: appleAppStoreIcon,
    width: 152,
  },
  link: 'https://motorway.onelink.me/gYoi/tpq5xs67',
  name: 'apple store',
  title: 'Apple App Store',
},
{
  description: texts.ctaGooglePlayDownload,
  icon: {
    height: 46,
    src: googlePlayStoreIcon,
    width: 152,
  },
  link: 'https://motorway.onelink.me/gYoi/eam4fi09',
  name: 'google play store',
  title: 'Google Play Store',
}];
